import generateUniqueId from '../../../scripts/utils/generate-unique-id.js';

export default function applyAriaLabelledbytoLink(block) {
  const headline = block.querySelector('h2');
  const link = block.querySelector('a');

  if (headline && link) {
    const linkId = generateUniqueId();
    link.id = linkId;
    link.setAttribute('aria-labelledby', `${headline.id} ${linkId}`);
    link.removeAttribute('title');
  }
}
